import { VueQueryPlugin, VueQueryPluginOptions } from "@tanstack/vue-query";
import Amplify from "aws-amplify";
import TimeAgo from "javascript-time-ago";
import de from "javascript-time-ago/locale/de";
import en from "javascript-time-ago/locale/en";
import fr from "javascript-time-ago/locale/fr";
import { createApp, Plugin } from "vue";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import GlobalMixins from "@/mixins/GlobalMixins";
import ToastMixin from "@/mixins/ToastMixin";
import App from "./App.vue";
import awsconfig from "./aws-exports";
import i18n from "./i18n";
import "./index.css";
import router from "./router";
import highCharts from "./services/highcharts";
import logger from "./services/logger";
import store from "./store";

Amplify.configure(awsconfig);

const app = createApp(App);

logger.init(app);
TimeAgo.addDefaultLocale(en);
TimeAgo.addLocale(de);
TimeAgo.addLocale(fr);

const vueQueryPluginOptions: VueQueryPluginOptions = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        retry: false,
        staleTime: 15000,
        useErrorBoundary: (error) => {
          logger.error(error);
          return false;
        },
      },
      mutations: {
        onError: (error) => {
          logger.error(error);
        },
      },
    },
  },
};
app
  .use(i18n)
  .use(store)
  .use(router)
  .use(highCharts)
  .use(VueQueryPlugin, vueQueryPluginOptions)
  .use(Toast as unknown as Plugin)
  .mixin(GlobalMixins)
  .mixin(ToastMixin)
  .mount("#app");
